/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItemPromoCode_item$ref = any;
export type CartItemTitle_item$ref = any;
export type CartItemTitle_item = {
    readonly title: string | null;
    readonly isArt: boolean | null;
    readonly pdpURL: string | null;
    readonly createdDate: string | null;
    readonly creators: ReadonlyArray<{
        readonly creator: {
            readonly name: string | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": CartItemPromoCode_item$ref;
    readonly " $refType": CartItemTitle_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItemTitle_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "hasUserId",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isArt",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pdpURL",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdDate",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "creators",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemCreator",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "creator",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Creator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasUserId",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "CartItemPromoCode_item",
                    "args": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '63b02c240afd8c1d7fa4e6783d0d7953';
export default node;
